import React from 'react'
import { Typography } from '@mui/material'
import { FormControl } from '@mui/material'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { Dayjs } from 'dayjs'
import { colors } from 'src/theme'
import tw from 'twin.macro'

interface Props extends DatePickerProps<Dayjs> {
  name?: string
  label?: string
  error?: boolean
  css?: any
}

export const BasicDatePicker = ({ label, css, error, ...props }: Props) => {
  return (
    <div css={css}>
      <Typography css={tw`mb-1`} variant="h6" color={colors.GRAY_COOL_GRAY}>
        {label}
      </Typography>
      <FormControl fullWidth error={error}>
        <DatePicker
          {...props}
          slotProps={{
            ...props.slotProps,
            textField: {
              ...props.slotProps?.textField,
              FormHelperTextProps: {
                sx: { mx: 0 },
              },
            },
          }}
        />
      </FormControl>
    </div>
  )
}
